import { getBoldFont, getMediumFont, getRegularFont } from '../../../../utils/Utils';

/// /////////////////////////////////////////////////////////  Primary
export const textPrimary_7_0 = (globJSON, simPlatform) => ({
  fontFamily: `${getRegularFont(globJSON, simPlatform)}`,
  fontSize: 7.0,
  color: globJSON.configurations.theme.colors.primary_font_color,
});

export const textPrimary_7_5 = (globJSON, simPlatform) => ({
  fontFamily: `${getRegularFont(globJSON, simPlatform)}`,
  fontSize: 7.5,
  color: globJSON.configurations.theme.colors.primary_font_color,
});
export const textPrimary_8_1 = (globJSON, simPlatform) => ({
  fontFamily: `${getRegularFont(globJSON, simPlatform)}`,
  fontSize: 8.1,
  color: globJSON.configurations.theme.colors.primary_font_color,
});
export const textPrimary_8_7 = (globJSON, simPlatform) => ({
  fontFamily: `${getRegularFont(globJSON, simPlatform, true)}`,
  fontSize: 8.7,
  color: globJSON.configurations.theme.colors.primary_font_color,
});
export const textPrimary_9_3 = (globJSON, simPlatform) => ({
  fontFamily: `${getMediumFont(globJSON, simPlatform)}`,
  fontSize: 9.3,
  color: globJSON.configurations.theme.colors.primary_font_color,
});
export const textPrimary_9_2 = (globJSON, simPlatform) => ({
  fontFamily: `${getRegularFont(globJSON, simPlatform)}`,
  fontSize: 9.3,
  color: globJSON.configurations.theme.colors.primary_font_color,
});
export const textPrimary_10_0 = (globJSON, simPlatform) => ({
  fontFamily: `${getMediumFont(globJSON, simPlatform)}`,
  fontSize: 10,
  color: globJSON.configurations.theme.colors.primary_font_color,
});
export const textPrimary_10_3 = (globJSON, simPlatform) => ({
  fontFamily: `${getRegularFont(globJSON, simPlatform)}`,
  fontSize: 10.3,
  color: globJSON.configurations.theme.colors.primary_font_color,
});
export const textPrimary_10_4 = (globJSON, simPlatform) => ({
  fontFamily: `${getBoldFont(globJSON, simPlatform)}`,
  fontWeight: 500,
  fontSize: 10.4,
  color: globJSON.configurations.theme.colors.primary_font_color,
});
export const textPrimary_11_0 = (globJSON, simPlatform) => ({
  fontFamily: `${getRegularFont(globJSON, simPlatform)}`,
  fontSize: 11,
  color: globJSON.configurations.theme.colors.primary_font_color,
});

export const textPrimary_10_9 = (globJSON, simPlatform) => ({
  fontFamily: `${getMediumFont(globJSON, simPlatform)}`,
  fontSize: 11,
  color: globJSON.configurations.theme.colors.primary_font_color,
});
export const textPrimary_11_6 = (globJSON, simPlatform) => ({
  fontFamily: `${getRegularFont(globJSON, simPlatform)}`,
  fontSize: 11.6,
  color: globJSON.configurations.theme.colors.primary_font_color,
});

export const textPrimary_13_0 = (globJSON, simPlatform) => ({
  fontFamily: `${getMediumFont(globJSON, simPlatform)}`,
  fontSize: 13,
  color: globJSON.configurations.theme.colors.primary_font_color,
});
export const textPrimary_13_9 = (globJSON, simPlatform) => ({
  fontFamily: `${getRegularFont(globJSON, simPlatform)}`,
  fontSize: 13.9,
  color: globJSON.configurations.theme.colors.primary_font_color,
});

export const textPrimary_14_0 = (globJSON, simPlatform) => ({
  fontFamily: `${getMediumFont(globJSON, simPlatform)}`,
  fontSize: 14,
  color: globJSON.configurations.theme.colors.primary_font_color,
});

export const textPrimary_16_0 = (globJSON, simPlatform) => ({
  fontSize: 16,
  color: globJSON.configurations.theme.colors.primary_font_color,
});
export const textPrimary_18_6 = (globJSON, simPlatform) => ({
  fontFamily: `${getMediumFont(globJSON, simPlatform)}`,
  fontSize: 18.6,
  color: globJSON.configurations.theme.colors.primary_font_color,
});
export const textPrimary_20_9 = (globJSON, simPlatform) => ({
  fontFamily: `${getMediumFont(globJSON, simPlatform)}`,
  fontSize: 20.9,
  color: globJSON.configurations.theme.colors.primary_font_color,
});

export const textPrimary_26_2 = (globJSON, simPlatform) => ({
  fontFamily: `${getRegularFont(globJSON, simPlatform)}`,
  fontSize: 26.2,
  color: globJSON.configurations.theme.colors.primary_font_color,
});
/// ///////////////////////////////////////////////////////// Secondary
export const textSecondary_7_0 = (globJSON, simPlatform) => ({
  fontFamily: `${getRegularFont(globJSON, simPlatform)}`,
  fontSize: 7,
  color: globJSON.configurations.theme.colors.secondary_font_color,
});

export const textSecondary_7_5 = (globJSON, simPlatform) => ({
  fontFamily: `${getMediumFont(globJSON, simPlatform)}`,
  fontSize: 7.5,
  color: globJSON.configurations.theme.colors.secondary_font_color,
});

export const textSecondary_8_0 = (globJSON, simPlatform) => ({
  fontFamily: `${getRegularFont(globJSON, simPlatform)}`,
  fontSize: 8,
  color: globJSON.configurations.theme.colors.secondary_font_color,
});

export const textSecondary_9_3 = (globJSON, simPlatform) => ({
  fontFamily: `${getRegularFont(globJSON, simPlatform)}`,
  fontSize: 9.3,
  color: globJSON.configurations.theme.colors.secondary_font_color,
});

export const textSecondary_12_2 = (globJSON, simPlatform) => ({
  fontFamily: `${getRegularFont(globJSON, simPlatform)}`,
  fontSize: 12.2,
  color: globJSON.configurations.theme.colors.secondary_font_color,
});

export const textSecondary_14_0 = (globJSON, simPlatform) => ({
  fontFamily: `${getRegularFont(globJSON, simPlatform)}`,
  fontSize: 14,
  color: globJSON.configurations.theme.colors.secondary_font_color,
});

/// /////////////////////////////////////////////////////////  Link
export const textLink_7_0 = (globJSON, simPlatform) => ({
  fontFamily: `${getMediumFont(globJSON, simPlatform)}`,
  fontSize: 7,
  color: globJSON.configurations.theme.colors.links_icons_color,
});
export const textLink_9_3 = (globJSON, simPlatform) => ({
  fontFamily: `${getMediumFont(globJSON, simPlatform)}`,
  fontSize: 9.3,
  color: globJSON.configurations.theme.colors.links_icons_color,
});
export const textLink_13_0 = (globJSON, simPlatform) => ({
  fontFamily: `${getMediumFont(globJSON, simPlatform)}`,
  fontSize: 13,
  color: globJSON.configurations.theme.colors.links_icons_color,
});
/// ///////////////////////////////////////////////////////// tertiary
export const textTertiary_8_0 = (globJSON, simPlatform) => ({
  fontFamily: `${getRegularFont(globJSON, simPlatform)}`,
  fontSize: 8,
  color: globJSON.configurations.theme.colors.tertiary_icons_color,
});
/// ///////////////////////////////////////////////////////// cta_font
export const textCtaFont_8_1 = (globJSON, simPlatform) => ({
  fontFamily: `${getRegularFont(globJSON, simPlatform)}`,
  fontSize: 8.1,
  color: globJSON.configurations.theme.colors.cta_font_color,
});
export const textCtaFont_10_4 = (globJSON, simPlatform) => ({
  fontFamily: `${getMediumFont(globJSON, simPlatform)}`,
  fontSize: 10.4,
  color: globJSON.configurations.theme.colors.cta_font_color,
});

export const textCtaFont_12_2 = (globJSON, simPlatform) => ({
  fontFamily: `${getMediumFont(globJSON, simPlatform)}`,
  fontSize: 12.2,
  color: globJSON.configurations.theme.colors.cta_font_color,
});
export const textCtaFont_18_6 = (globJSON, simPlatform) => ({
  fontFamily: `${getMediumFont(globJSON, simPlatform)}`,
  fontSize: 18.6,
  color: globJSON.configurations.theme.colors.cta_font_color,
});
/// ///////////////////////////////////////////////////////// primary_cta
export const textPrimaryCta_12_2 = (globJSON, simPlatform) => ({
  fontFamily: `${getMediumFont(globJSON, simPlatform)}`,
  fontSize: 12.2,
  color: globJSON.configurations.theme.colors.primary_cta_color,
});
